//与assets/scss/element-variables.scss下的$--color-primary变量保持一致
const primaryColor = '#d72c24';
export const appColors = {
    primaryColor: primaryColor,
    successColor: "#67C23A",
    warningColor: "#E6A23C",
    dangerColor: "#F56C6C",
    infoColor: "#909399",
    primaryText: "#303133",
    regularText: "#606266",
    secondaryText: "#909399",
    placeholder: "#C0C4CC",
    borderBase: "#DCDFE6",
    borderLight: "#E4E7ED",
    borderLighter: "#EBEEF5",
    borderExtralight: "#F2F6FC",
    backgroundB: "#000000",
    backgroundW: "#FFFFFF",
    goldStart: "#f8ebd7",
    goldEnd: "#efd2ae",
    goldText: "#d4af37",
    greyText: "#909399",
    correctTextColor() {
        return this.dangerColor;
    },
    correctBgColor() {
        return this.warningColor;
    },
};

export const appSize = {
    /**
     * 左边菜单栏宽度百分比
     */
    leftNavWidthPercent: 15,
};

export const appEnv = {
    isLocalServer: process.env.VUE_APP_IS_LOCAL_SERVER == 'yes',
    localUrl: process.env.VUE_APP_LOCAL_URL,
    apiBaseUrl: process.env.VUE_APP_SERVER_URL,
    isProd: process.env.NODE_ENV === 'production',
};

export const LocalStorageKey = {
    appConfigs: 'appConfigs',
    currUser: 'currUser'
};

export const SessionStorageKey = {
    checkArticleId: "checkArticleId",
    checkActionType: "checkActionType",
};

export const qEditorDefaultOptions = {
    modules: {
        toolbar: [
            [{ font: [] }, { size: [] }],
            ["bold", "italic", "underline", "strike"],
            [{ color: [] }, { background: [] }],
            [{ script: "super" }, { script: "sub" }],
            [{ header: "1" }, { header: "2" }, "blockquote", "code-block"],
            [
                { list: "ordered" },
                { list: "bullet" },
                { indent: "-1" },
                { indent: "+1" },
            ],
            ["direction", { align: [] }],
            // ["link", "image", "video", "formula"],
            ["link", "formula"],
            ["clean"],
        ],
        history: true,
        clipboard: true
    },
    formats: [
        "bold",
        "italic",
        "underline",
        "strike",
        "blockquote",
        "code-block",
        "header",
        "list",
        "script",
        "indent",
        "direction",
        "size",
        "font",
        "color",
        "background",
        "align",
        "link",
        "code",
        "formula",
        // 'image'
        // 'video'
    ],
};
